import { createContext, useContext } from "react";

import { IikoIntegrationState } from "features/IikoIntegration/hooks/useIikoIntegrationState";

export const IikoIntegrationContext = createContext<IikoIntegrationState | null>(null);

export const useIikoIntegrationContext = (): IikoIntegrationState => {
    const state = useContext(IikoIntegrationContext);

    if (!state) {
        throw new Error("useIikoIntegrationContext вызван вне IikoIntegrationContext.Provider");
    }

    return state;
};
